'use strict' /* eslint-disable no-console */;

/**
 * productCarousel adds a 4-slides-to-show Slick carousel
 * for Related Product and Related Titles card blocks
 */

import jQuery from 'jquery';
import 'slick-carousel';

const productCarousel = (function($) {
  /**
	 * addProductCarousel
	 *
	 * Initializes a new instance of a Slick carousel
	 *
	 * @param productCarousel: instance of a carousel element
	 * @param productCarouselId: id of the carousel element
	 */
  function addProductCarousel(productCarousel, productCarouselId) {
    const slideClass = '.related__item';
    const totalSlideCount = productCarousel.querySelectorAll(slideClass).length;

    if (totalSlideCount > 2) {
      $(productCarousel).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        arrows: true,
        infinite: false,
        accessibility: true,
        appendArrows: `#${productCarouselId} + .slick-arrows`,
        prevArrow:
          '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button>',
        nextArrow:
          '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button>',
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
    } else if (totalSlideCount <= 2) {
      const slides = productCarousel.querySelectorAll(slideClass);
      const carouselContainer = document.querySelector('.related__container');
      const noSlickClass = 'no-slick';

      carouselContainer.classList.add(noSlickClass);
      slides.forEach(slide => slide.classList.add(noSlickClass));
    }
  }

  /**
	 * init
	 *
	 * Targets product carousels on the page
	 * and passes each one through to addProductCarousel()
	 */
  function init() {
    const carousels = document.querySelectorAll('.js-product-carousel');

    setTimeout(() => {
      [].forEach.call(carousels, carousel => {
        const productCarousel = carousel.querySelector('[id^="carousel-"]');
        const productCarouselId = productCarousel.id;
        addProductCarousel(productCarousel, productCarouselId);
      });
    }, 150);
  }

  window.addEventListener('DOMContentLoaded', init);
})(jQuery);

export default productCarousel;



// WEBPACK FOOTER //
// ./resources/assets/js/product-carousel.js